var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentAddedToTrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 5H21.4648C22.1277 5.0001 22.7633 5.26341 23.232 5.73203L34.268 16.768C34.7366 17.2367 34.9999 17.8723 35 18.5352V33.75C35 34.7446 34.6049 35.6984 33.9017 36.4017C33.1984 37.1049 32.2446 37.5 31.25 37.5H15C14.0054 37.5 13.0516 37.1049 12.3483 36.4017C11.6451 35.6984 11.25 34.7446 11.25 33.75V23.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5.625V15C22.5 15.663 22.7634 16.2989 23.2322 16.7678C23.7011 17.2366 24.337 17.5 25 17.5H34.375",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.25V18.125C12.5033 18.3721 12.457 18.6174 12.3639 18.8464C12.2708 19.0753 12.1328 19.2833 11.9581 19.4581C11.7833 19.6328 11.5753 19.7708 11.3464 19.8639C11.1174 19.957 10.8721 20.0033 10.625 20C9.6875 20 8.75 19.2891 8.75 18.125V6.875C8.75 4.48516 10.0445 2.5 12.5 2.5C14.9555 2.5 16.25 4.4375 16.25 6.82656V17.6664C16.25 21.0258 14.0766 23.75 10.625 23.75C7.17344 23.75 5 21.0266 5 17.6664V11.25",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentAddedToTrade);
export default __webpack_public_path__ + "static/media/attachment-added-to-trade.741d6299e9c1d81b83d77d893db1e817.svg";
export { ForwardRef as ReactComponent };